import { idtype, imageAsset } from "querypieces";

export default `
    ${idtype}
      images {
        ${imageAsset}
      }
`;